import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";
import { useAxiosPost } from "../../hooks/useAxios";
import { useParams } from "react-router-dom";

import { ServiceType } from "../../utils/enums";
import { Table } from "../../components/Table";
import { NOTICES } from "../../api/endpointMap";
import UserFilterDropdown, {
  ALL_USERS,
  toQueryParam as userFilterToQueryParam,
} from "../../components/UserFilterDropdown";

export const GSTAdditionalNoticesList = ({ serviceType }) => {
  const { clientId } = useParams();
  const [notices, setNotices] = useState([]);
  // User-filter (USER_LEVEL_CLIENT_ASSIGNMENT.md §7.2).
  const [userFilter, setUserFilter] = useState(ALL_USERS);

  const columns = [
    { label: "Notice ID", key: "id" },
    { label: "Client", key: "client" },
    { label: "Ref ID", key: "ref_id" },
    { label: "Type", key: "type_of_notice" },
    { label: "Issued Date", key: "date_of_issuance" },
  ];

  const [fetchGSTAdditionalNoticeList, { loading: loadingNotice }] =
    useAxiosPost(NOTICES.GST_ADDITIONAL_LIST);

  useEffect(() => {
    const payload = {
      start: 0,
      page_length: 20,
      search_query: ` ${clientId ? clientId : ""}`,
    };
    // §7.2: scope to a specific user / Unassigned / All. ALL_USERS sentinel
    // → omit param entirely so BE auto-scopes per role.
    const userParam = userFilterToQueryParam(userFilter);
    if (userParam !== undefined) payload.assigned_user_id = userParam;

    fetchGSTAdditionalNoticeList({
      payload,
      cb: (data) => {
        setNotices(data?.result?.records || []);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, userFilter]);

  return (
    <>
      <PageTitle title="GST Additional Notice List" />
      <div className="flex items-center justify-end gap-2 mb-2">
        <UserFilterDropdown
          value={userFilter}
          onChange={setUserFilter}
          portal={serviceType}
        />
      </div>
      <Table
        columns={columns}
        data={notices}
        itemsPerPage={10}
        type="additional-notices"
        serviceType={serviceType}
        rowRedirection={`/${ServiceType.GSTIN}/notice-details`}
      />
    </>
  );
};
